import ModalAlert from '../components/modals/ModalAlert';
import ModalConfirm from '../components/modals/ModalConfirm';
import ModalPrompt from '../components/modals/ModalPrompt';
import ModalProofResult from "../components/modals/ModalProofResult";

const defaultModalMap = {
    ModalConfirm, ModalAlert, ModalPrompt, ModalProofResult
};

export default function (injection, Vue, initialModalMap = {}) {
    // &modal
    const modal = {
        _nextZIndex: 10001,
        _queue: [],
        _vcMap: {},
        _fnMap: {},
        mask: {
            show () {
                injection.Vue.$store.commit('mask', {isShow: true, zIndex: modal._nextZIndex - 1});
            },
            hide () {
                injection.Vue.$store.commit('mask', {isShow: false, zIndex: 9999});
            },
            sub () {
                injection.Vue.$store.commit('mask', {isShow: true, zIndex: modal._nextZIndex - 2});
            },
            check () {
                if (modal._queue.length === 0) {
                    this.hide();
                } else {
                    this.show();
                }
            }
        },
        /**
         * 添加一个Modal的Vue组件
         * @param  Constructor Vue组件
         * @param  name        索引名称
         */
        extend (Constructor, name) {
            this._vcMap[name] = Vue.extend(Constructor);
            if ('alias' in Constructor) {
                this.constructModal(Constructor.alias, this._vcMap[name]);
            }
        },
        /**
         * 构建窗体
         * @param  FrameExtended Vue构造器
         * @param  options       传入组件init方法的options
         * @return               [description]
         */
        build (FrameExtended, options) {
            var ext = new FrameExtended({
                store: injection.store,
                router: injection.router
            }).$mount();
            ext.$el.style.zIndex = modal._nextZIndex++;
            ext.close = function () {
                var that = this;
                Vue.nextTick(() => {
                    var i;
                    for (i = 0; i < modal._queue.length; i++) {
                        if (modal._queue[i] === that) {
                            modal._nextZIndex--;
                            modal._queue.splice(i, 1);
                            break;
                        }
                    }
                    modal.mask.check();
                    document.body.removeChild(that.$el);
                    that.$destroy(true);
                });
            };
            modal.mask.show();
            modal._queue.push(ext);
            Vue.nextTick(() => {
                document.body.appendChild(ext.$el);
                // 创建完毕，调用modal的modalCreated
                if ('modalCreated' in FrameExtended.sealedOptions) {
                    Vue.nextTick(() => {
                        var defaultOptions =
                            ('defaultOptions' in FrameExtended.sealedOptions)
                                ? (FrameExtended.sealedOptions.defaultOptions()) : {};
                        FrameExtended.sealedOptions.modalCreated.call(ext, Object.assign(defaultOptions, options));
                        Vue.nextTick(() => {
                            modal.adjustPosition(ext);
                        });
                    });
                }
            });
            return ext;
        },
        /**
         * 使窗体居中
         * @param  {[type]} frameInstance [description]
         * @return {[type]}               [description]
         */
        adjustPosition (frameInstance) {
            const currentStyle = window.getComputedStyle(frameInstance.$el);

            const h = parseInt(currentStyle['height']) + parseInt(currentStyle['padding-top']) + parseInt(currentStyle['padding-bottom']);
            const windowInHeight = window.innerHeight;
            let scrollTop = document.body.scrollTop;
            let scrollLeft = window.pageXOffset;
            let top = 0;
            const w = parseInt(currentStyle['width']);
            switch (currentStyle['position']) {
                case 'fixed':
                    frameInstance.$el.style.marginLeft = -(Math.ceil(w / 2)) + 'px';
                    frameInstance.$el.style.marginTop = -(Math.ceil(h / 2)) + 'px';
                    break;
                case 'absolute':
                    if (scrollTop === 0 && document.documentElement.scrollTop > 0) {
                        scrollTop = document.documentElement.scrollTop;
                    }
                    if (h < document.body.scrollHeight) {
                        top = scrollTop + Math.ceil((windowInHeight - h) / 2);
                    } else {
                        top = scrollTop + 100;
                    }
                    top = top < scrollTop ? scrollTop + 100 : top;
                    if (top < 0) {
                        top = 100;
                    }
                    frameInstance.$el.style.top = `${top}px`;
                    frameInstance.$el.style.marginLeft = -(Math.ceil((w ) / 2 - scrollLeft)) + 'px';
                    frameInstance.$el.style.marginTop = '0px';
                    break;
                default:
                    break;
            }
        },
        constructModal (alias, FrameExtended) {
            modal._fnMap[alias] = function (options) {
                return modal.build(FrameExtended, options);
            };
            Object.defineProperty(modal, alias, {
                get () {
                    return modal._fnMap[alias];
                }
            });
        }
    };

    Object.defineProperties(injection, {
        modal: {
            get () {
                return modal;
            }
        }
    });
    Object.defineProperties(Vue.prototype, {
        $modal: {
            get () {
                return modal;
            }
        }
    });

    Object.keys(defaultModalMap).forEach(val => {
        initialModalMap[val] = defaultModalMap[val];
    });

    for (let i in initialModalMap) {
        modal.extend(initialModalMap[i], i);
    }
}
